export { default } from './PanelCollapsible'
